import { render, staticRenderFns } from "./EntityDetails.vue?vue&type=template&id=6f4d8035&scoped=true"
import script from "./EntityDetails.vue?vue&type=script&lang=js"
export * from "./EntityDetails.vue?vue&type=script&lang=js"
import style0 from "./EntityDetails.vue?vue&type=style&index=0&id=6f4d8035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d8035",
  null
  
)

export default component.exports